import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { secondsToTime } from '@alfa-bank/site-helpers-transform/time/seconds-to-time';
import { calculateSeconds } from '@alfa-bank/site-helpers-transform/time/calculate-seconds';

import type { TCountdownTimer, IDeps } from './models';
import { CountdownTimer as Component } from './countdown-timer';

export const CountdownTimer = createWidget<IDeps, TCountdownTimer>({
    secondsToTime,
    calculateSeconds,
})(Component);
